import React from "react";
import { motion, useReducedMotion } from "framer-motion";
import Navigation from "../components/Navigation";
import FormContact from "../components/FormContact";
import SEO from "../components/SEO";

import HeroBgImg from "../assets/images/lyon2.webp";

function Contact() {
  const prefersReduced = useReducedMotion();

  const fadeUp = (delay = 0) =>
    prefersReduced
      ? {}
      : {
          initial: { opacity: 0, y: 20 },
          whileInView: { opacity: 1, y: 0 },
          viewport: { once: true, margin: "-60px" },
          transition: { duration: 0.55, ease: [0.25, 0.1, 0.25, 1], delay },
        };

  return (
    <main className="contact-page">
      <SEO
        title="Contact"
        path="/contact"
        description="Contactez Alexandre Jack pour réserver votre séance photo à Lyon. Réponse sous 48h."
      />
      <Navigation />

      {/* ── HERO ─────────────────────────────────────── */}
      <section className="contact-hero" aria-label="Contact — introduction">
        <div className="contact-hero__bg" aria-hidden="true">
          <img src={HeroBgImg} alt="" loading="eager" decoding="async" />
        </div>
        <div className="contact-hero__overlay" aria-hidden="true" />
        <div className="contact-hero__content">
          <p className="contact-hero__eyebrow">Photographe&nbsp;·&nbsp;Lyon</p>
          <h1 className="contact-hero__title">Contact</h1>
          <p className="contact-hero__tagline">Parlons de votre projet</p>
        </div>
      </section>

      {/* ── FORM SECTION ──────────────────────────────── */}
      <section className="contact-section" aria-label="Formulaire de contact">
        <div className="contact-section__inner">

          <div className="contact-section__aside">
            <motion.p className="contact-aside__label" {...fadeUp(0)}>
              Prise de contact
            </motion.p>
            <motion.h2 className="contact-aside__heading" {...fadeUp(0.06)}>
              Demandez un devis
            </motion.h2>
            <motion.p className="contact-aside__body" {...fadeUp(0.12)}>
              Décrivez votre projet et je vous recontacte rapidement pour
              construire ensemble la prestation qui vous correspond.
            </motion.p>
            <motion.address className="contact-aside__address" {...fadeUp(0.18)}>
              <span className="contact-aside__address-label">Zone d'intervention</span>
              Lyon & environs
            </motion.address>
          </div>

          <motion.div
            className="contact-section__form"
            {...(prefersReduced
              ? {}
              : {
                  initial: { opacity: 0, y: 30 },
                  whileInView: { opacity: 1, y: 0 },
                  viewport: { once: true, margin: "-60px" },
                  transition: { duration: 0.65, ease: [0.25, 0.1, 0.25, 1], delay: 0.1 },
                })}
          >
            <FormContact />
          </motion.div>

        </div>
      </section>
    </main>
  );
}

export default Contact;
